import { FC } from 'react'
import { useDispatch } from 'react-redux'

import { removeNotification } from 'store/actions/notifications'
import { t } from 'translations'
import { Format } from 'services/Dates'

import { Button as MerinioButton } from 'ui'

type Props = MData.Notification & {
  key: string
}

const Notification: FC<Props> = props => {
  const { _id, date, description = '', icon, isErrorNotification, title, type = 'success', fadeClass, rawDescription } = props
  const dispatch = useDispatch()
  // Function to transform the provided action triggered date into a humain format (ex: 1 min ago)
  const getHumanizedDuration = (date: Date) => Format(date, { outFormat: 'distance' })

  return (
    <div className={`merinio-toast merinio-toast-${type} ${fadeClass}`} role="alert">
      <div className="merinio-toast-header">
        <div className="d-flex">
          {icon ? <i className={`far fa-fw fa-${icon} my-auto pr-1`} /> : null} <strong className="mr-auto">{t(title)}</strong>{' '}
          <span className="ml-auto merinio-toast-close" onClick={() => dispatch(removeNotification(_id))}>
            <i className="fas fa-times" />
          </span>
        </div>
        {date ? <small className="text-muted d-block">{getHumanizedDuration(date)}</small> : null}
      </div>
      {description || isErrorNotification ? (
        <div className="merinio-toast-body">
          {rawDescription ? description : t(description)}
          {isErrorNotification ? (
            <div>
              <MerinioButton type="button" color="error" className="mt-2" onClick={() => window.Intercom('showNewMessage')}>
                {t('components.notification.REPORT_INTERCOM')}
              </MerinioButton>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default Notification
